<elcia-card [title]="'todo.status'|translate">
  <elcia-todo-settings-status/>
</elcia-card>

